import { Platform } from 'react-native';

export const getDeviceType = (): string => {
  if (Platform.OS === 'web') {
    // Check if web is mobile-sized
    if (typeof window !== 'undefined') {
      const userAgent = navigator.userAgent.toLowerCase();
      if (/mobile|android|iphone|ipad|tablet/.test(userAgent)) {
        return 'mobile';
      }
      if (window.innerWidth <= 768) {
        return 'tablet';
      }
    }
    return 'desktop';
  }
  return Platform.OS === 'ios' || Platform.OS === 'android' ? 'mobile' : 'desktop';
};

export const getOperatingSystem = (): string => {
  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    const userAgent = navigator.userAgent;
    if (userAgent.includes('Windows')) return 'Windows';
    if (userAgent.includes('Mac')) return 'macOS';
    if (userAgent.includes('Linux')) return 'Linux';
    if (userAgent.includes('Android')) return 'Android';
    if (userAgent.includes('iPhone') || userAgent.includes('iPad')) return 'iOS';
    return 'Unknown';
  }
  return Platform.OS;
};

export const getScreenResolution = (): string => {
  if (typeof window !== 'undefined' && window.screen) {
    return `${window.screen.width}x${window.screen.height}`;
  }
  return 'unknown';
};

export const getViewportSize = (): string => {
  if (typeof window !== 'undefined') {
    return `${window.innerWidth}x${window.innerHeight}`;
  }
  return 'unknown';
};

export const getBrowserLanguage = (): string => {
  if (typeof navigator !== 'undefined') {
    return navigator.language || 'en-US';
  }
  return 'en-US';
};

export const generateSessionId = (): string => {
  return Date.now().toString() + Math.random().toString(36).substr(2, 9);
}; 